import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  headingcolor: {
    color: theme.palette.text.primary,
    opacity: 1,
  },
  usernotify: {
    "& input": {
      color: theme.palette.primary.main,
    },
  },
  addButton: {
    marginTop: theme.spacing(1),
  },
  editIconBtn: {
    margin: "-12px",
  },
  operatorLink: {
    padding: "18px 14px",
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
  },
  operatorInputs: {
    marginBottom: "18px",
  },
}));

export default useStyles;
